/* eslint-disable no-empty-pattern */
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from 'react-csv';

export function FormInput({
  inputType,
  inputName,
  inputID,
  value,
  handlerChange
}) {
  return (
    <>
      <input
        type={inputType}
        className="formControl"
        id={inputID}
        name={inputName}
        defaultValue = {value}
        onChange={(e) => handlerChange(e)}
      />
    </>
  );
}

export function DateFiled({handlerChange, value, dateFormat}) {
  return (
    <>
      <DatePicker
        showIcon
        dateFormat={dateFormat}
        className="formControl"
        selected={value}
        onChange={handlerChange} 
      />
    </>
  );
}

export function FormSelect({optionValue, optionName}) {
  return (
    <>
      <option label={optionName} value={optionValue}/>
    </>
  );
}

export function FormTextarea({textName, handlerChange, value}) {
  return (
    <>
      <textarea
        className="formControl h-24"
        name={textName}
        onChange={handlerChange}
        defaultValue= {value}
      />
    </>
  );
}

export function WorkShift({optionValue}) {
  return (
    <>
      <select className="p-1 px-1 border rounded text-sm  md:w-auto w-full">
        <option>{optionValue}</option>
      </select>
    </>
  );
}

export function ExportCsvFile({tableData, nameCsv}) {
  return (
    <>
      <button className="btn-md btn-add mr-2">
        <span className="fa fa-file-export mr-2" />
        <CSVLink  className="exportCsvClass"
         data={tableData ? tableData :""} filename={nameCsv} >
          Export to CSV
      </CSVLink>
        {/* Export CSV File */}
      </button>
    </>
  );
}
